import {Text, Pressable, StyleSheet} from "react-native";
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

/**
 * This edit button is ONLY VISIBLE for camp owners when viewing their own camp page.
 * 
 * A floating action button that toggles between Edit and Save modes for a camp.
 * When in Edit mode, displays "Save camp" with a save icon.
 * When not in Edit mode, displays "Edit camp" with an edit icon.
 * 
 * @param {boolean} isEditing - Current editing state
 * @param {function} setIsEditing - Function to toggle editing state
 */
const CampHostEditButton = ({isEditing, setIsEditing, onToggle = null}) => {

    const styles = StyleSheet.create({
        button: {
            backgroundColor: '#000000', 
            borderRadius: 40,
            padding: 13,
            flexDirection: 'row',
            alignItems: 'center',
        },
        buttonText: {
            fontSize: 16,
            color: 'white',
            fontWeight: '600',
            marginLeft: 8
        }
    });

    return (
        <Pressable 
            style={styles.button}
            onPress={() => {
                if (onToggle) {
                    onToggle();
                } else {
                    setIsEditing(!isEditing);
                }
            }}
        >
            <MaterialCommunityIcons 
                name={isEditing ? 'check-underline' : 'draw'} 
                size={20}
                color='white'
            />
            <Text style={styles.buttonText}>
                {isEditing ? 'Save camp' : 'Edit camp'}
            </Text>
        </Pressable>
    );
};

export default CampHostEditButton;